<script>
import TitleSlot from '@/components/TitleSlot'
import TextSlot from '@/components/TextSlot'

export default
{
    name: 'pricing',

    props:
    {
    },

    created ()
    {
    },

    render () 
    {
        var citizensRecapNumber = Number(this.citizensNumber).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ')
        if (this.citizensNumber < this.sliderMin + this.sliderInterval) citizensRecapNumber = 'moins de ' + citizensRecapNumber
        if (this.citizensNumber > this.sliderMax - this.sliderInterval) citizensRecapNumber = 'plus de ' + citizensRecapNumber

        const costRecap = this.citizensNumber < this.sliderMax
            ? <div>Ce qui vous revient à <b>{Number(this.monthlyCost).toLocaleString('fr', { style: 'currency', currency: 'EUR' })}</b>/mois</div>
            : <div>Vous êtes éligible à une offre personnalisée</div>

        return (
            <div class='pricing'>
                <title-slot>Payez seulement ce que vous utilisez</title-slot>
                <text-slot>
                    Notre offre s'adapte à la taille de votre commune en proposant des prix fléxibles, clairs et sans coût caché, en fonction du traffic généré.
                    <br />
                    Tout est compris (infrastructure serveurs, maintenance, mises à jour, distribution sur les différentes plateformes, support technique, gestion juridique...).
                </text-slot>
                <div class='price-calculator'>
                    <text-slot class='citizens-recap'> Ma commune compte <b>{citizensRecapNumber}</b> habitants </text-slot>
                    <vue-slider v-model={this.citizensNumber} on-change={n => this.citizensNumber = n} adsorb={true} min={this.sliderMin} max={this.sliderMax}
                        interval={500} tooltip='none' />
                    <text-slot class='cost-recap'>{ costRecap }</text-slot>
                </div>

                <div class='request-trial' on-click={this.onRequestTrialClicked}>
                    <button>
                        Bénéficier de 2 mois d'essai gratuit et sans engagement
                    </button>
                </div>
            </div>
        )
    },

    mounted ()
    {
    },

    data () 
    {
        return {
            sliderMax: 20000,
            sliderMin: 500,
            sliderInterval: 500,
            citizensNumber: 3500
        }
    },

    computed:
    {
        monthlyCost ()
        {
            const cost = (Math.pow(this.citizensNumber, 1.65) - 1) / this.citizensNumber + 40
            
            return Math.round(cost / 10) * 10
        }
    },

    methods:
    {
        onRequestTrialClicked ()
        {
            this.$router.push('/trial-request')
        }
    },

    components:
    {
        TitleSlot,
        TextSlot,
    }
}
</script>

<style lang='less'>
@import '~@/styles/main.less';

.pricing
{
    .request-trial
    {
        button
        {
            background: var(--theme-accent-color);
            color: white;
            padding: 3vh 1vw;
            border-radius: 6px;
            font-weight: bold;
            font-family: Nunito;
            cursor: pointer;
            box-shadow: 0px 3px 10px 1px #00000030;
            transition: all 0.2s linear;

            width: 100%;
            margin-left: 0;
            font-size: 3vw;
            margin-top: 4vh;

            .OnTablet({ font-size: 2.5vw; });

            .OnDesktop({
                width: 70%;
                margin-left: 15%;
                font-size: 1.4vw;
                margin-top: 0;
            });

            .OnLarge({
                width: 50%;
                margin-left: 25%;
                font-size: 1vw;
                margin-top: 0;
            });

            &:hover
            {
                background: white;
                box-shadow: 0 3px 10px 1px var(--theme-accent-color-30-percent);
                color: var(--theme-accent-color);
            }
        }
    }

    .price-calculator
    {
        padding: 6vh 0;

        .OnDesktop({ padding: 8vh 6vw; });
        .OnLarge({ padding: 8vh 10vw; });

        .citizens-recap
        {
            text-align: center;
            margin-top: 1vw;
            margin-bottom: 1.5vh;
            font-size: 4.3vw;

            .OnTablet({ font-size: 3.3vw; });
            .OnDesktop({ font-size: 1.3vw; });
            .OnLarge({ font-size: 1.1vw; });
        }

        .vue-slider
        {
            margin-top: 0.7vw;
            height: 1.5vw !important;

            .OnTablet({ height: 1vw !important; });
            .OnDesktop({ height: 0.3vw !important; });
            .OnLarge({ height: 0.2vw !important; });

            .vue-slider-process
            {
                background-color: var(--theme-accent-color);
            }
            .vue-slider-rail
            {
                background-color: rgba(0, 0, 0, 0.05);
            }
            .vue-slider-dot
            {
                width: 6vw !important;
                height: 6vw !important;

                .OnTablet({
                    width: 4vw !important;
                    height: 4vw !important;
                });

                .OnDesktop({
                    width: 1.8vw !important;
                    height: 1.8vw !important;
                });

                .OnLarge({
                    width: 1.2vw !important;
                    height: 1.2vw !important;
                });

                .vue-slider-dot-handle-focus
                {
                    box-shadow: 0 0 1px 2px var(--theme-accent-color-30-percent);
                }
            }
        }

        .cost-recap
        {
            text-align: center;
            margin-top: 1.5vw;
            margin-top: 2vh;
            font-size: 3.8vw;

            .OnTablet({ font-size: 3vw; });
            .OnDesktop({ font-size: 1.2vw; });
            .OnLarge({ font-size: 1vw; });
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/components/Pricing.vue